import { CellType } from "./apis/api";
import { HighlightableLetterData, PlayableLetterData } from "./ui/UIState";

export interface Settings {
    trayLength: number;
    playerName: string;
}

export function cellTypeToDetails(cell_type: CellType): {
    className: string;
    text: string;
} {
    let className: string;
    let text: string;

    switch (cell_type) {
        case CellType.Normal:
            className = "grid-spot-normal";
            text = "";
            break;
        case CellType.DoubleWord:
            className = "grid-spot-double-word";
            text = "Double Word Score";
            break;
        case CellType.DoubleLetter:
            className = "grid-spot-double-letter";
            text = "Double Letter Score";
            break;
        case CellType.TripleLetter:
            className = "grid-spot-triple-letter";
            text = "Triple Letter Score";
            break;
        case CellType.TripleWord:
            className = "grid-spot-triple-word";
            text = "Triple Word Score";
            break;
        case CellType.Start:
            className = "grid-spot-start";
            text = "★";
            break;
    }

    return { className: className, text: text };
}

export function addNTimes<T>(array: T[], toAdd: T, times: number) {
    for (let i = 0; i < times; i++) {
        array.push(toAdd);
    }
}

export const GRID_LENGTH = 15;

export function findNextEmptySpace(
    position: number,
    direction: "RIGHT" | "DOWN",
    reverse: boolean,
    boardLetters: HighlightableLetterData[],
    playerLetters: PlayableLetterData[],
): number | null {
    let current_x = position % GRID_LENGTH;
    let current_y = Math.floor(position / GRID_LENGTH);

    // we loop because we want to skip over letters that are already set
    const shift_by = reverse ? -1 : 1;
    while (
        Math.min(current_x, current_y) >= 0 &&
        Math.max(current_x, current_y) < GRID_LENGTH
    ) {
        if (direction === "RIGHT") {
            current_x += shift_by;
        } else {
            current_y += shift_by;
        }

        const new_position = current_x + current_y * GRID_LENGTH;
        let tray_letter_at_position = false; // need to also check if the player put a letter in the spot
        for (const letter of playerLetters) {
            if (letter != null && letter.grid_index == new_position) {
                tray_letter_at_position = true;
                break;
            }
        }

        if (
            current_x < GRID_LENGTH &&
            current_y < GRID_LENGTH &&
            boardLetters[new_position] == null &&
            !tray_letter_at_position
        ) {
            return new_position;
        }
    }

    // if we reached this point without returning then we went off the board, remove arrow
    return null;
}

const LOGBASE = 10000;

export function unprocessAIRandomness(processedAIRandomness: number): string {
    const x = (100 * (LOGBASE ** processedAIRandomness - 1)) / (LOGBASE - 1);
    return x.toFixed(0);
}

export function unprocessedAIProportion(processedProportion: number): string {
    return (100 * (1 - processedProportion)).toFixed(0);
}

export function processAIRandomness(x: number): number {
    return Math.log(1 + ((LOGBASE - 1) * x) / 100) / Math.log(LOGBASE);
}

export function processProportionDictionary(x: number): number {
    return 1.0 - x / 100;
}
